//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import contactpersonen from '~/graphql/queries/contactpersonen.gql';

export default {
  apollo: {
    contactpersonen: {
      query: contactpersonen,
    },
  },
  data: () => ({
    contactPersonenImg: require('~/assets/img/contactpersonen.jpg'),
    contactpersonen: [],
  }),
};
